// extracted by mini-css-extract-plugin
export default {"container":"H1_container__Sowjl"};